module.exports = __webpack_public_path__ + "img/dashboard-icon.93514c1e.svg";